import { useRef } from 'react';
import { toast } from 'sonner';

/**
 * GoogleFormEmbed
 *
 * Renders an embedded Google Form iframe.
 * - isPreview=true: shows a non-interactive "Form Preview" badge above the iframe;
 *   the form itself remains fully interactive so cookie-consent dialogs work.
 *   No onSubmitted fires in preview mode.
 * - onSubmitted: called when the iframe navigates (second load = form submission).
 */
export default function GoogleFormEmbed({ embedUrl, onSubmitted, isPreview = false }) {
  const loadCountRef = useRef(0);

  const handleLoad = () => {
    loadCountRef.current += 1;
    // First load = form ready. Second load = form submitted (iframe navigates to thank-you page).
    if (loadCountRef.current >= 2 && !isPreview && onSubmitted) {
      onSubmitted();
    }
  };

  return (
    <div className="relative w-full rounded-lg overflow-hidden border border-gray-200" data-testid="google-form-embed">
      {isPreview && (
        <div
          className="flex items-center gap-2 px-3 py-2 bg-amber-50 border-b border-amber-200"
          data-testid="form-embed-preview-banner"
        >
          <span className="text-xs font-semibold text-amber-700 uppercase tracking-wide">Form Preview</span>
          <span className="text-xs text-amber-600">— Any test submissions will be picked up by the next sync cycle.</span>
        </div>
      )}
      <iframe
        src={embedUrl}
        width="100%"
        height="640"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
        title="Registration Form"
        onLoad={handleLoad}
        className="block w-full"
        style={{ minHeight: 640 }}
      />
    </div>
  );
}
